import React, {
    Component,
    PureComponent
} from 'react'
import {
    Nav,
    NavLink,
    Link,
} from 'react-router-dom'
import { actionTypes } from '../constants';
import moment from 'moment';
import _ from 'lodash-joins';

import fetch from '../utils/fetch';
import awsconfig from '../awsconfig';

import Icon from '@material-ui/core/Icon';

import EnhancedTable from '../widgets/table-enhanced'
import LinkButton from '../widgets/button-link'
import ChipDetails from '../widgets/chip-details'
import InputClickEditable from '../widgets/input-click-editable'
import DropdownFilterMenu from '../widgets/dropdown-filter-menu';

import ButtonBase from "@material-ui/core/ButtonBase";
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';

import ReportActionsMenu from './reports-actions-menu';

class Container extends Component {
    constructor(props) {
        super(props)
        this.state = {
            error: null,
            is_loaded: false,
            filter_by_status: 'all'
        }
    }

    async componentDidMount() {
        this.props.dispatch({type: actionTypes.REPORTS_FETCH_ALL})
        this.props.dispatch({type: actionTypes.USERS_FETCH_ALL})
        this.props.dispatch({type: actionTypes.DEPARTMENTS_FETCH_ALL})
        // this.props.dispatch({type: actionTypes.SNACKBAR, snackbar: {severity: 'info', text: 'Lorem ipsum'}})
    }

    render() {
        if(!this.props.reports.is_loaded || !this.props.users.is_loaded || !this.props.departments.is_loaded){
            return 'Loading...'  // hide while loading
        }

        console.log(this.props);

        let table = '';
        if(this.props.reports.list.length > 0){
            let reports = this.props.reports.list;
            // left-join any user data
            reports = _.hashInnerJoin(
                reports,
                r=>r.reporter,
                this.props.users.list,
                u=>u.cognitoId,
                (r, u)=>({...r, __user: u})
            );
            // console.log(reports)
            // left-join any department data
            reports = _.hashInnerJoin(
                reports,
                r=>_.get(r, ['__user', 'clientId'], null),
                this.props.departments.list,
                d=>d._id,
                (r, d)=>({...r, __department: d})
            );
            // console.log(reports)
            // console.log(this.state.filter_by_status)
            if(this.state.filter_by_status === 'stuck'){
                reports = reports.filter(r=>!r.vcaClaimId);
            }else if(this.state.filter_by_status === 'archived'){
                reports = reports.filter(r=>r.isArchived === true);
            }else if(this.state.filter_by_status === 'internal'){
                reports = reports.filter(r=>r.fromInternalOnlyClient === true);
            }else{
                // 'all'
                reports = reports.filter(r=>r.isArchived !== true);
            }
            // console.log(reports)
            table = <EnhancedTable
                data={reports.map(r=>{
                    // console.log(r)
                    return {
                        ...r,
                        vcaClaimIdSort: (r.vcaClaimId ? r.vcaClaimId : 'Z'),
                        reporterName: (r.__user ? `${r.__user.firstname} ${r.__user.lastname}` : '(User not found)'),
                        role: (r.__user ? r.__user.role : ''),
                        department: r.__department || {},
                    }
                })}
                order='desc'
                orderBy='createdAt'
                rowsPerPage={5}
                selectable={true}
                selectableKey='_id'
                columns={[
                  {id: 'vcaClaimIdSort', label: 'VCA #' },
                  {id: 'accidentNumber', label: 'Accident #' },
                  {id: 'address', label: 'Address' },
                  {id: 'reporterName', label: 'Reporter' },
                  {id: 'role', label: 'Reporter Role' },
                  {id: 'createdAt', label: 'Created' },
                  {id: null, label: 'Actions'}
                ]}
                buildTableRow={report=>{
                    // prevent r from being mutated when rendering nested copmonent!
                    let r = JSON.parse(JSON.stringify(report));
                    return (
                        <React.Fragment>
                            <EnhancedTable.Cell>
                                <ChipDetails
                                    label={`${r.vcaClaimId ? r.vcaClaimId : 'Not Submitted'}`}
                                    status={`${r.vcaClaimId ? 'success' : 'error'}`}
                                    tooltip={''}
                                />
                            </EnhancedTable.Cell>
                            <EnhancedTable.Cell>
                                <InputClickEditable
                                    key={r._id}
                                    value={r.accidentNumber}
                                    readonly={r.vcaClaimId}
                                    onChange={value=>{
                                        this.props.dispatch({
                                            type: actionTypes.REPORTS_UPDATE_ONE,
                                            id: r._id,
                                            data: {
                                                ...report,
                                                accidentNumber: value
                                            }
                                        })
                                    }}
                                />
                            </EnhancedTable.Cell>
                            <EnhancedTable.Cell>{r.address}</EnhancedTable.Cell>
                            <EnhancedTable.Cell>
                                {r.reporterName}
                                <div style={{whiteSpace: 'nowrap', fontSize: '0.6rem'}}>
                                    {r.department.name}
                                </div>
                            </EnhancedTable.Cell>
                            <EnhancedTable.Cell>{r.role}</EnhancedTable.Cell>
                            <EnhancedTable.Cell>{moment(r.createdAt).format('MMM Do, YYYY')}</EnhancedTable.Cell>
                            <EnhancedTable.Cell>
                                <ReportActionsMenu report={r} users={this.props.users} departments={this.props.departments} dispatch={this.props.dispatch} history={this.props.history} match={this.props.match}/>
                            </EnhancedTable.Cell>
                        </React.Fragment>
                    );
                }}
            />
        }

        return (
            <React.Fragment> {/* parent is div.page */}
                <div className="page-nav">
                    <div className="breadcrumb">
                        <h1>Reports</h1>
                    </div>
                    <div className="page-actions">
                        <LinkButton to={`/app/reports`} className="button button-primary button-wide">
                            Go to VCA&nbsp;&nbsp;<Icon>open_in_new</Icon>
                        </LinkButton>
                    </div>
                </div>
                <div className="table-actions">
                    <DropdownFilterMenu
                        label="By Status"
                        value={this.state.filter_by_status}
                        onChange={e=>{this.setState({filter_by_status: e.target.value})}}
                        choices={[
                            {
                                value: 'all',
                                label: 'All'
                            },
                            {
                                value: 'stuck',
                                label: 'Unsubmitted Reports'
                            },
                            {
                                value: 'internal',
                                label: 'Internal Reports'
                            },
                            {
                                value: 'archived',
                                label: 'Archived Reports'
                            },
                        ]}
                    />
                </div>
                <div className="card card-table">
                    {table}
                </div>
            </React.Fragment>
        )
    }
}

import { connect } from 'react-redux'
export default connect(
    (state)=>{
        return {
            reports: state.reports,
            users: state.users,
            departments: state.departments,
        }
    },
    (dispatch)=>{
        return {
            dispatch: dispatch
        }
    },
    null,
    {pure: false}
)(Container);